import mylistBoxTc from '../my-listBox-tc/src/main'
/* istanbul ignore next */
mylistBoxTc.install = function(Vue) {
  Vue.component(mylistBoxTc.name, mylistBoxTc);
};
export default mylistBoxTc



// WEBPACK FOOTER //
// ./src/components/my-listBox-tc/index.js